import React, { useState } from 'react';
import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as ErpAgentActions from '../../../actions/erpAgentActions';

import * as classes from './CreateFsmAgentModal.module.css';

const CreateFsmAgentModal = ({
    activeNavCompany,
    createErpAgent,
    setCreateFsmAgentModalOpen,
    ...props
}) => {

    const [integrationName, setIntegrationName] = useState('');
    const [driverType, setDriverType] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleCreateIntegration = async () => {
        const agent = {
            agentType: driverType[0],
            name:      integrationName
        };

        setIsLoading(true);
        await createErpAgent(activeNavCompany.id, agent);
        setIsLoading(false);
    };

    const handleDriverTypeChange = event => {
        setDriverType(event.target.value);
    };

    const handleNameChange = event => {
        setIntegrationName(event.target.value);
    };

    const MenuProps = {
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 500
            },
        },
    };

    return (
        <BobModal
            title={'New FSM Integration'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => setCreateFsmAgentModalOpen(false)}
        >
            <div className={classes.ModalBody}>
                <div className={classes.BodyContainer}>
                    <TextField
                        id="standard-required"
                        label={<span>FSM Integration Name<span className={classes.Required}> *</span></span>}
                        placeholder="Enter"
                        value={integrationName}
                        onChange={handleNameChange}
                        size="small"
                        inputProps={{
                            style: { fontSize: 14 }
                        }}
                        InputLabelProps={{
                            className: classes.NameLabel
                        }}
                        className={classes.NameInput}
                        variant="outlined"
                    />
                    <FormControl variant="outlined" size="small" className={classes.Select}>
                        <InputLabel
                            style={{
                                backgroundColor: 'white',
                                paddingRight:    '5px',
                                paddingLeft:     '10px'
                            }}
                        >
                            <span>FSM Driver Type<span className={classes.Required}> *</span></span>
                        </InputLabel>
                        <Select
                            value={driverType}
                            classes={{ root: classes.SelectFont }}
                            MenuProps={MenuProps}
                            multiple
                            renderValue={(selected) => selected.map(type => type).join(', ')}
                            onChange={handleDriverTypeChange}
                            className={classes.select}
                            inputProps={{
                                name: 'driverType',
                                id:   'driverType'
                            }}
                        >
                            <MenuItem
                                key={0}
                                value={'Signature'}
                            >
                                <Checkbox style={{ color: 'black' }} checked={driverType.indexOf('Signature') > -1} />
                                <ListItemText primary={'Signature'} />
                            </MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className={classes.ButtonsContainer}>
                    <BobCancelButton
                        disabled={isLoading}
                        onClick={() => setCreateFsmAgentModalOpen(false)}
                        className={classes.CancelButton}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        disabled={isEmpty(integrationName) || isEmpty(driverType)}
                        onClick={() => handleCreateIntegration()}
                        className={isLoading || isEmpty(integrationName) || isEmpty(driverType) ? classes.DisabledButtons : classes.Buttons}
                        label={'Create'}
                        iconSize={15}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </BobModal>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
});

const mapDispatchToProps = {
    ...ErpAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateFsmAgentModal);
